import './index.scss';
import { IconKeyboardBackspace } from '../../../icons/svgs';

function ContentPreview({ slides, selectedSlide, selectedSlideIndex, lessonTitle }) {

    const getSlideIndex = () => {
        let index = slides.indexOf(selectedSlide) ?? 0;
        if(index>=0) {
            return index + 1;
        }
        return 0;
    }

  return (
    <div className="tbcourse-content-preview">

        <div className="tbcourse-content-preview-header">
            <div className="tbcourse-content-preview-header-navigator">
                <div className="btn">
                    <IconKeyboardBackspace/>
                    <span className="lesson-name" title={lessonTitle}>{lessonTitle}</span>
                </div>
            </div>
            <div className="tbcourse-content-preview-header-info">
                <span>{getSlideIndex()} / {slides.length}</span>
            </div>
        </div>
        <div className="tbcourse-content-preview-body">
            {selectedSlide?.render()}
        </div>
        <div className='tbcourse-content-preview-footer'>
            {selectedSlide?.actions()}
        </div>
    </div>
  );
}

export default ContentPreview;
